/* Match catalogue words against names, types, tags and SKUs, excluding care-copy matches; fall back to full-text when that finds nothing. */
(() => {
  const tokens = (value) => value.match(/[\p{L}\p{N}]+(?:[-/][\p{L}\p{N}]+)*/gu) || [];
  const scopedQuery = (value) => {
    if (/[:"]/u.test(value)) return value; // Preserve deliberate Shopify search syntax.
    const words = tokens(value);
    const stopWords = new Set(['the', 'no']); // Shopify omits these from its title index.
    if (words.every(word => stopWords.has(word.toLowerCase()))) return value;
    return words.map(word => `(title:${word} OR product_type:${word} OR tag:${word} OR variants.sku:${word}${stopWords.has(word.toLowerCase()) ? ' OR title:*' : ''})`).join(' ');
  };
  window.waCatalogueSearch = { tokens, scopedQuery };
  // Keep old plain search links working, including searches shared before this repair.
  const url = new URL(window.location.href);
  if (document.body.dataset.waSearchPage === 'true' && url.searchParams.get('q')) {
    const query = url.searchParams.get('q');
    const results = document.querySelector('[data-wa-search-result-count]');
    if (query.startsWith('(title:') && results?.dataset.waSearchResultCount === '0') {
      // 30/10/2026: when the name/type/tag/SKU search finds nothing ("trucker", "sweatshirt", "cotton", typos such as
      // "jakcet"), use Shopify's full-text, typo-tolerant index instead of showing a dead end.
      const original = document.querySelector('#Search-In-Template')?.value;
      if (original && original !== query) {
        url.searchParams.set('q', original);
        url.searchParams.set('wa_fulltext', '1');
        window.location.replace(url.href);
        return;
      }
    }
    const scoped = scopedQuery(query);
    if (!url.searchParams.has('wa_fulltext') && scoped && scoped !== query) {
      url.searchParams.set('q', scoped);
      window.location.replace(url.href);
      return;
    }
  }
  document.addEventListener('submit', (event) => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement) || event.defaultPrevented || form.getAttribute('role') !== 'search') return;
    const input = form.querySelector('input[type="search"]');
    if (!input?.value.trim()) return;
    const query = scopedQuery(input.value.trim());
    if (!query || query === input.value.trim()) return;
    let hidden = form.querySelector('[data-wa-scoped-query]');
    if (!hidden) {
      hidden = document.createElement('input');
      hidden.type = 'hidden';
      hidden.dataset.waScopedQuery = '';
      form.append(hidden);
    }
    hidden.name = 'q';
    hidden.value = query;
    input.removeAttribute('name'); // Keep the visible input and predictive query human-readable.
  });
})();
